"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentOrdersToRateMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class RecentOrdersToRateMapper {
    toDomain(result) {
        return {
            orders: lodash_1.default.get(result, "data.orders")
                .map((o) => ({
                id: o.id,
                idHuman: o.idHuman,
                state: o.state,
                withdrawRange: o.withdrawRange,
                withdrawLocation: o.withdrawLocation,
                updated: o.updated,
            }))
        };
    }
}
exports.RecentOrdersToRateMapper = RecentOrdersToRateMapper;
